import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Paprika } from '../../styles/theme';

/**
 * Hairline separator with a centered Newsreader-italic "ou". Uses tonal
 * hairlines, never a hard 1px rule (per the design system).
 */
export const Divider: React.FC<{ label?: string }> = ({ label = 'ou' }) => (
  <View style={styles.row}>
    <View style={styles.line} />
    <Text style={styles.label}>{label}</Text>
    <View style={styles.line} />
  </View>
);

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
    marginVertical: 4,
  },
  line: {
    flex: 1,
    height: 1,
    backgroundColor: Paprika.hairline,
  },
  label: {
    fontFamily: 'Newsreader-Italic',
    fontSize: 13,
    color: Paprika.textMuted,
  },
});
